import siteConfig from "site-config";
import { fetchJSON } from "lib/fetch";
import { useQuery, QueryConfig, QueryKey } from "react-query";
import lodashKeyBy from "lodash/keyBy";
import { IBrand } from "containers/management/management-types";
import { BrandRecord as Brand } from "records/brand";

const BRANDS = "brands";

export enum LandingPageTypes {
    HomepageId = "home_page_id",
    BuyerLandingPageId = "buyer_landing_page_layout_id",
    CatalogsLinksToPage = "catalogs_links_to_page",
}

export interface IPreferences {
    buyer_landing_page_layout_id?: string;
    catalogs_links_to_page?: string;
}

export const useFetchBrands = () => {
    return useQuery<{ ids: string[]; entities: { [key: string]: IBrand } }, string>(BRANDS, () =>
        fetchJSON<{ [id: string]: IBrand }>(`${siteConfig.api}/brands`, {
            method: "GET",
            noDomain: true,
        }).then((brandsResponse) => {
            const entities = lodashKeyBy(brandsResponse, "_id");
            const ids = Object.keys(entities);
            return {
                ids,
                entities,
            };
        })
    );
};

export function useFetchBrandById(brandId: string, options?: QueryConfig<Brand>) {
    return useQuery<Brand, QueryKey>(
        [BRANDS, brandId],
        () => {
            return fetchJSON<Brand>(`${siteConfig.api}/brand/${brandId}`, {
                method: "GET",
                noDomain: true,
            }).then((brandResponse) => {
                return new Brand(brandResponse);
            });
        },
        options
    );
}

export function getBrand(brandId: string) {
    return fetchJSON<{ name: string }>(`${siteConfig.api}/brand/${brandId}`, {
        noDomain: true,
    });
}
